import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { ConnectionMonitorModalComponent } from './connection-monitor/connection-monitor-modal.component';
import { ConnectionMonitorComponent } from './connection-monitor/connection-monitor.component';
import { ConnectionService } from './connection-service.service';

@NgModule({
    declarations: [
        ConnectionMonitorComponent,
        ConnectionMonitorModalComponent
    ],
    providers: [
        ConnectionService
    ],
    imports: [
        CommonModule,
        MatDialogModule
    ],
    exports: [
        ConnectionMonitorComponent
    ]
})
export class ConnectionMonitorModule {
}
